/**
 * Docs article — "On this page" scrollspy.
 *
 * Builds the TOC from the article's h2/h3 (if not already server-rendered)
 * and highlights the current section via IntersectionObserver, matching the
 * handoff (rootMargin '-80px 0px -70% 0px').
 */
export function initDocsToc() {
	const article = document.querySelector('.docs-main .prose');
	const toc = document.querySelector('.docs-toc');
	if (!article || !toc) return;

	const headings = Array.from(article.querySelectorAll('h2, h3'));
	if (!headings.length) return;

	// Build links if the TOC body is empty (server may pre-render it).
	let list = toc.querySelector('.toc-list');
	if (!list) {
		list = document.createElement('div');
		list.className = 'toc-list';
		toc.appendChild(list);
	}
	if (!list.children.length) {
		headings.forEach((h) => {
			if (!h.id) {
				h.id = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
			}
			const a = document.createElement('a');
			a.href = '#' + h.id;
			a.textContent = h.textContent;
			if (h.tagName === 'H3') a.classList.add('sub');
			list.appendChild(a);
		});
	}

	const links = new Map();
	list.querySelectorAll('a').forEach((a) => links.set(a.getAttribute('href').slice(1), a));

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					links.forEach((a) => a.classList.remove('active'));
					const link = links.get(entry.target.id);
					if (link) link.classList.add('active');
				}
			});
		},
		{ rootMargin: '-80px 0px -70% 0px' }
	);
	headings.forEach((h) => observer.observe(h));
}
